/* eslint-disable */
// Translations for MandatePage (step 01.5) and ContractPage (step 04).
export const mandateTranslations = {
  fr: {
    mandate: {
      badge: 'Cadre de la relation',
      headerTitle: 'Votre projet peut passer à l\'étape de recherche',
      headerBody: "Votre cahier des charges a été examiné par Yuville. Nous pouvons maintenant entreprendre la recherche et la qualification de manufacturiers susceptibles de répondre à vos exigences. Avant le début de cette recherche, nous vous invitons à prendre connaissance du <b class=\"text-brand-yellow\">mandat de sourcing et d'accompagnement</b> applicable à votre projet.",
      client: 'Client', project: 'Projet', statusLabel: 'Statut du mandat',
      acceptedTitle: 'Mandat accepté',
      acceptedDesc: 'Vous serez recontacté pour la suite du projet.',
      acceptedOn: 'Accepté le', acceptedMethod: 'méthode',
      methodDocusign: 'Signature électronique DocuSign',
      methodDocusignHint: 'via DocuSign — recommandée',
      methodInternal: 'Acceptation en ligne',
      methodInternalHint: 'nom · entreprise · horodatage',
      downloadSigned: 'Télécharger le document signé',
      docLabel: 'Document contractuel',
      openPdf: 'Ouvrir en PDF',
      signPrompt: 'Prenez connaissance du mandat, puis signez pour permettre le démarrage de la recherche.',
      signBtn: 'Signer le mandat',
      signDialogTitle: 'Signature du mandat',
      chooseMethod: 'Choisissez la méthode de signature :',
      phName: 'Nom du signataire', phCompany: 'Entreprise', phEmail: 'Courriel professionnel',
      readConfirm: "J'ai lu l'intégralité du mandat et je confirme l'accepter au nom de l'entreprise indiquée.",
      cancel: 'Annuler',
      submitDocusign: 'Signer via DocuSign', submitInternal: 'Accepter',
      missing: 'Champs manquants', missingDesc: 'Merci de compléter tous les champs et confirmer la lecture.',
      error: 'Erreur', errorDesc: "Acceptation impossible.",
      errAccess: 'Accès impossible', back: "Retour à l'accueil",
      statuses: {
        to_prepare: 'À préparer', sent: 'Envoyé', waiting_acceptance: 'En attente de signature',
        accepted: 'Accepté', refused: 'Refusé', expired: 'Expiré', not_required: 'Non requis',
      },
    },
    contract: {
      badge: 'Étape 04 · Contrat et suivi',
      title: 'Votre contrat commercial',
      subtitle: "Consultez, téléchargez et signez le contrat commercial. Une fois signé, le suivi de production s'active.",
      signedTitle: 'Contrat signé', signedDesc: 'Merci !',
      missing: 'Champs manquants', missingDesc: 'Merci de compléter.',
      acceptedTitle: 'Contrat accepté', acceptedDesc: 'Suivi de production activé.',
      acceptedOn: 'Signé le', internalMethod: 'signature interne',
      downloadSigned: 'Télécharger le contrat signé',
      docLabel: 'Contrat commercial',
      manufacturer: 'Manufacturier',
      openPdf: 'Ouvrir en PDF',
      trackingTitle: 'Suivi de production',
      dueDate: 'Échéance', completedDate: 'Complété le',
      signPrompt: 'Prenez connaissance du contrat, puis signez pour activer le suivi.',
      signBtn: 'Signer le contrat',
      signDialogTitle: 'Signature du contrat',
      chooseMethod: 'Choisissez la méthode de signature :',
      methodDocusign: 'Signature électronique',
      methodInternal: 'Acceptation en ligne',
      methodInternalHint: 'nom + IP + horodatage',
      phName: 'Nom du signataire', phCompany: 'Entreprise', phEmail: 'Courriel professionnel',
      readConfirm: "J'ai lu l'intégralité du contrat et je l'accepte au nom de l'entreprise indiquée.",
      cancel: 'Annuler',
      submitDs: 'Signer via DocuSign', submitInternal: 'Accepter',
      errAccess: 'Accès impossible', back: 'Retour',
    },
  },
  en: {
    mandate: {
      badge: 'Framework of our relationship',
      headerTitle: 'Your project can move to the sourcing stage',
      headerBody: "Your specification has been reviewed by Yuville. We are now ready to begin the search and qualification of manufacturers able to meet your requirements. Before we start, we invite you to review the <b class=\"text-brand-yellow\">sourcing and advisory mandate</b> that governs your project.",
      client: 'Client', project: 'Project', statusLabel: 'Mandate status',
      acceptedTitle: 'Mandate accepted',
      acceptedDesc: 'We will get back to you for the next steps.',
      acceptedOn: 'Accepted on', acceptedMethod: 'method',
      methodDocusign: 'DocuSign electronic signature',
      methodDocusignHint: 'DocuSign — recommended',
      methodInternal: 'Online acceptance',
      methodInternalHint: 'name · company · timestamp',
      downloadSigned: 'Download the signed document',
      docLabel: 'Contractual document',
      openPdf: 'Open PDF',
      signPrompt: 'Review the mandate and sign to start the sourcing.',
      signBtn: 'Sign the mandate',
      signDialogTitle: 'Sign the mandate',
      chooseMethod: 'Choose a signing method:',
      phName: 'Signer name', phCompany: 'Company', phEmail: 'Business email',
      readConfirm: 'I have read the entire mandate and I accept it on behalf of the company above.',
      cancel: 'Cancel',
      submitDocusign: 'Sign via DocuSign', submitInternal: 'Accept',
      missing: 'Missing fields', missingDesc: 'Please complete all fields and confirm you have read the document.',
      error: 'Error', errorDesc: 'Acceptance failed.',
      errAccess: 'Access denied', back: 'Back to home',
      statuses: {
        to_prepare: 'To prepare', sent: 'Sent', waiting_acceptance: 'Awaiting signature',
        accepted: 'Accepted', refused: 'Declined', expired: 'Expired', not_required: 'Not required',
      },
    },
    contract: {
      badge: 'Step 04 · Contract & follow-up',
      title: 'Your commercial contract',
      subtitle: 'Review, download and sign the commercial contract. Once signed, production tracking is activated.',
      signedTitle: 'Contract signed', signedDesc: 'Thank you!',
      missing: 'Missing fields', missingDesc: 'Please complete all fields.',
      acceptedTitle: 'Contract accepted', acceptedDesc: 'Production tracking is now active.',
      acceptedOn: 'Signed on', internalMethod: 'internal signature',
      downloadSigned: 'Download the signed contract',
      docLabel: 'Commercial contract',
      manufacturer: 'Manufacturer',
      openPdf: 'Open PDF',
      trackingTitle: 'Production tracking',
      dueDate: 'Due date', completedDate: 'Completed on',
      signPrompt: 'Review the contract and sign to activate production tracking.',
      signBtn: 'Sign the contract',
      signDialogTitle: 'Sign the contract',
      chooseMethod: 'Choose a signing method:',
      methodDocusign: 'Electronic signature',
      methodInternal: 'Online acceptance',
      methodInternalHint: 'name + IP + timestamp',
      phName: 'Signer name', phCompany: 'Company', phEmail: 'Business email',
      readConfirm: 'I have read the entire contract and I accept it on behalf of the company above.',
      cancel: 'Cancel',
      submitDs: 'Sign via DocuSign', submitInternal: 'Accept',
      errAccess: 'Access denied', back: 'Back',
    },
  },
  zh: {
    mandate: {
      badge: '合作关系框架',
      headerTitle: '您的项目可以进入寻源阶段',
      headerBody: '您的需求说明已由 Yuville 审阅。我们现在可以启动符合您要求的制造商搜索与资质审核。在开始之前，请阅读适用于您项目的<b class="text-brand-yellow">寻源与陪伴授权书</b>。',
      client: '客户', project: '项目', statusLabel: '授权书状态',
      acceptedTitle: '授权书已接受',
      acceptedDesc: '我们将与您联系以推进后续工作。',
      acceptedOn: '接受时间：', acceptedMethod: '方式',
      methodDocusign: 'DocuSign 电子签名',
      methodDocusignHint: '推荐使用 DocuSign',
      methodInternal: '在线接受',
      methodInternalHint: '姓名 · 公司 · 时间戳',
      downloadSigned: '下载已签署的文件',
      docLabel: '合同性文件',
      openPdf: '打开 PDF',
      signPrompt: '请阅读授权书并签名以启动寻源。',
      signBtn: '签署授权书',
      signDialogTitle: '签署授权书',
      chooseMethod: '请选择签名方式：',
      phName: '签字人姓名', phCompany: '公司', phEmail: '工作邮箱',
      readConfirm: '本人已阅读完整授权书，并以上述公司名义接受其条款。',
      cancel: '取消',
      submitDocusign: '通过 DocuSign 签署', submitInternal: '接受',
      missing: '字段缺失', missingDesc: '请填写所有字段并确认已阅读。',
      error: '错误', errorDesc: '接受失败。',
      errAccess: '无法访问', back: '返回首页',
      statuses: {
        to_prepare: '待准备', sent: '已发送', waiting_acceptance: '待签署',
        accepted: '已接受', refused: '已拒绝', expired: '已过期', not_required: '不需要',
      },
    },
    contract: {
      badge: '第04步 · 合同与跟进',
      title: '您的商务合同',
      subtitle: '查阅、下载并签署商务合同。签署后，生产跟踪自动激活。',
      signedTitle: '合同已签署', signedDesc: '感谢您！',
      missing: '字段缺失', missingDesc: '请填写所有字段。',
      acceptedTitle: '合同已接受', acceptedDesc: '生产跟踪已激活。',
      acceptedOn: '签署时间：', internalMethod: '内部签名',
      downloadSigned: '下载已签署的合同',
      docLabel: '商务合同',
      manufacturer: '制造商',
      openPdf: '打开 PDF',
      trackingTitle: '生产跟踪',
      dueDate: '截止日期', completedDate: '完成时间',
      signPrompt: '请阅读合同并签署以激活跟踪。',
      signBtn: '签署合同',
      signDialogTitle: '签署合同',
      chooseMethod: '请选择签名方式：',
      methodDocusign: '电子签名',
      methodInternal: '在线接受',
      methodInternalHint: '姓名 + IP + 时间戳',
      phName: '签字人姓名', phCompany: '公司', phEmail: '工作邮箱',
      readConfirm: '本人已阅读完整合同，并以上述公司名义接受其条款。',
      cancel: '取消',
      submitDs: '通过 DocuSign 签署', submitInternal: '接受',
      errAccess: '无法访问', back: '返回',
    },
  },
};
